import React from 'react'
import PropTypes from 'prop-types'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { ODataLoader } from 'components/dataLoader'
import LoadingIndicator from 'components/loading/loadingIndicator'
import { api } from 'store/modules/winesInStock'
import { localized } from 'decorators'
import { withStyles } from '@material-ui/styles'
import { styles } from './index.css'

class WinesInStockDialog extends DialogBase {
  static propTypes = {
    context: PropTypes.shape({
      title: PropTypes.string,
      wineId: PropTypes.number
    }).isRequired
  }
  modalSize () { return dialogSizes.MD }
  modalTitle () { return this.props.context.title || super.modalTitle() }
  modalBody () { 
    return  (
      <ODataLoader
        dataSource={() => api.getBottlesOfWineStock({ wineId: this.props.context.wineId })}
        odata={false}
        render={this.renderBottles}
      />
    )
  }
  renderBottles = ({ loading, data = [] }) => {
    const { classes } = this.props
    if (loading) { return <LoadingIndicator /> }
    const total = data.length > 0 ? data.map(x => x.bottlesInStoragePlaceCount).reduce((total, curr) => total + curr) : 0
    return (
      <table className={classes.table}>
        <thead className={classes.tableHead}>
          <tr className={classes.tableRow}>
            <th>{this.props.localize('winesInStock.storagePlace')}</th>
            <th>{this.props.localize('winesInStock.bottlesCount')}</th>
          </tr>
        </thead>
        <tbody className={classes.tableBody}>
          {data.map((x, idx) => <tr key={`tr_${idx}`} className={classes.tableRow}><td>{x.storagePlaceName}</td><td>{x.bottlesInStoragePlaceCount}</td></tr>)}
        </tbody>
        <tfoot className={classes.tableBody}>
          <tr className={classes.tableRow}>
            <td className={classes.total}>{this.props.localize('winesInStock.total')}</td>
            <td className={classes.total}>{total}</td>
          </tr>
        </tfoot>
      </table>
    )
    
  }
}

export default withStyles(styles)(localized(WinesInStockDialog))
